import React from "react";
import { connect } from "react-redux";
import { getReport, getJobPackReports } from "./actions";
import { selectReport } from "./selectors";
import { Card, CardContent, CardHeader, Button } from "@material-ui/core";

import ReactToPrint from "react-to-print";
import { gridStyle, cellStyle } from "../gridHelper";
import { noSig } from "vrcore-dashboard/dist/utilities";

class HealthAndSafety extends React.Component {
    constructor(props) {
        super(props);
        const path = props.location.pathname.split("/");
        if (path[2] === "reports") {
            props.getReport(
                path[2].replace(/-/g, "_"),
                path[3],
                path[5].replace(/_/g, " ").replace(/\./g, ":"),
                path[4].replace(/-/g, "_")
            );
        } else {
            props.getJobPackReports(
                props.match.params.uprn,
                path[2].replace(/-/g, "_"),
                path[3],
                path[4].replace(/-/g, "_"),
                path[5].replace(/-/g, "_"),
                props.match.params.report_id
                    .replace(/_/g, " ")
                    .replace(/\./g, ":"),
                path[7].replace(/-/g, "_")
            );
        }
    }

    render() {
        let report = this.props.report === false ? [] : this.props.report;

        const gstyle = gridStyle;
        const cstyle = cellStyle;
        const color = this.props.color;
        return (
            <Card>
                <CardHeader title="Health & Safety Induction" />
                <CardContent>
                    <ReactToPrint
                        onBeforePrint={() => {
                            setTimeout(undefined, 2000);
                        }}
                        trigger={() => (
                            <Button
                                style={{
                                    fontSize: "30px",
                                    marginBottom: "10px"
                                }}
                                color="primary"
                                variant="contained"
                            >
                                Print
                            </Button>
                        )}
                        content={() => this.componentRef}
                    />
                    <div ref={el => (this.componentRef = el)}>
                        {this.props.header && <this.props.header />}

                        {/* <Typography variant="heading">
                            Health & Safety No:
                            {report.urn === undefined ? "N/A" : report.urn}
                        </Typography> */}

                        <div style={gstyle(3, 17, null, color)}>
                            <div style={cstyle(1, 1, 1, 17, false, true)}>
                                <b>Info</b>
                            </div>
                            <div style={cstyle(2, 1, 2, 9)}>
                                <b>User Name</b>
                            </div>
                            <div style={cstyle(2, 4, 2, 9, true)}>
                                {report.user_name}
                            </div>
                            <div style={cstyle(2, 9, 2, 17)}>
                                <b>Timestamp</b>
                            </div>
                            <div style={cstyle(2, 13, 2, 17, true)}>
                                {report.timestamp}
                            </div>
                        </div>
                        {report.name_1 !== "" && (
                            <div style={gstyle(6, 17, null, color)}>
                                <div style={cstyle(1, 1, 1, 17, false, true)}>
                                    <b>Person 1</b>
                                </div>
                                <div style={cstyle(2, 1, 2, 9)}>
                                    <b>Name</b>
                                </div>
                                <div style={cstyle(2, 4, 2, 9, true)}>
                                    {report.name_1}
                                </div>
                                <div style={cstyle(3, 1, 3, 9)}>
                                    <b>Date</b>
                                </div>
                                <div style={cstyle(3, 4, 3, 9, true)}>
                                    {report.date_1}
                                </div>

                                <div style={cstyle(4, 1, 4, 9)}>
                                    <b>Reason For Visit</b>
                                </div>
                                <div style={cstyle(4, 4, 4, 9, true)}>
                                    {report.reason_1}
                                </div>

                                <div style={cstyle(5, 1, 5, 9)}>
                                    <b>Time In</b>
                                </div>
                                <div style={cstyle(5, 4, 5, 9, true)}>
                                    {report.time_in_1}
                                </div>

                                <div style={cstyle(6, 1, 6, 9)}>
                                    <b>Time Out</b>
                                </div>
                                <div style={cstyle(6, 4, 6, 9, true)}>
                                    {report.time_out_1}
                                </div>
                                <div style={cstyle(2, 9, 7, 17)}>
                                    <img
                                        style={{
                                            width: "200px",
                                            height: "200px",
                                            margin: "auto"
                                        }}
                                        src={
                                            report.signature_1_url ===
                                                undefined ||
                                            report.signature_1_url === null ||
                                            report.signature_1_url === ""
                                                ? noSig
                                                : report.signature_1_url
                                        }
                                        alt="Signature"
                                    />
                                </div>
                            </div>
                        )}
                        {report.name_2 !== "" && (
                            <div style={gstyle(6, 17, null, color)}>
                                <div style={cstyle(1, 1, 1, 17, true)}>
                                    <b>Person 2</b>
                                </div>
                                <div style={cstyle(2, 1, 2, 9)}>
                                    <b>Name</b>
                                </div>
                                <div style={cstyle(2, 4, 2, 9, true)}>
                                    {report.name_2}
                                </div>
                                <div style={cstyle(3, 1, 3, 9)}>
                                    <b>Date</b>
                                </div>
                                <div style={cstyle(3, 4, 3, 9, true)}>
                                    {report.date_2}
                                </div>

                                <div style={cstyle(4, 1, 4, 9)}>
                                    <b>Reason For Visit</b>
                                </div>
                                <div style={cstyle(4, 4, 4, 9, true)}>
                                    {report.reason_2}
                                </div>

                                <div style={cstyle(5, 1, 5, 9)}>
                                    <b>Time In</b>
                                </div>
                                <div style={cstyle(5, 4, 5, 9, true)}>
                                    {report.time_in_2}
                                </div>

                                <div style={cstyle(6, 1, 6, 9)}>
                                    <b>Time Out</b>
                                </div>
                                <div style={cstyle(6, 4, 6, 9, true)}>
                                    {report.time_out_2}
                                </div>
                                <div style={cstyle(2, 9, 7, 17)}>
                                    <img
                                        style={{
                                            width: "200px",
                                            height: "200px",
                                            margin: "auto"
                                        }}
                                        src={
                                            report.signature_2_url ===
                                                undefined ||
                                            report.signature_2_url === null ||
                                            report.signature_url_2 === ""
                                                ? noSig
                                                : report.signature_2_url
                                        }
                                        alt="Signature"
                                    />
                                </div>
                            </div>
                        )}
                        {report.name_3 !== "" && (
                            <div style={gstyle(6, 17, 6.16)}>
                                <div style={cstyle(1, 1, 1, 17, true)}>
                                    <b>Person 3</b>
                                </div>
                                <div style={cstyle(2, 1, 2, 9)}>
                                    <b>Name</b>
                                </div>
                                <div style={cstyle(2, 4, 2, 9, false, true)}>
                                    {report.name_3}
                                </div>
                                <div style={cstyle(3, 1, 3, 9)}>
                                    <b>Date</b>
                                </div>
                                <div style={cstyle(3, 4, 3, 9, false, true)}>
                                    {report.date_3}
                                </div>

                                <div style={cstyle(4, 1, 4, 9)}>
                                    <b>Reason For Visit</b>
                                </div>
                                <div style={cstyle(4, 4, 4, 9, false, true)}>
                                    {report.reason_3}
                                </div>

                                <div style={cstyle(5, 1, 5, 9)}>
                                    <b>Time In</b>
                                </div>
                                <div style={cstyle(5, 4, 5, 9, false, true)}>
                                    {report.time_in_3}
                                </div>

                                <div style={cstyle(6, 1, 6, 9)}>
                                    <b>Time Out</b>
                                </div>
                                <div style={cstyle(6, 4, 6, 9, false, true)}>
                                    {report.time_out_3}
                                </div>
                                <div style={cstyle(2, 9, 7, 17)}>
                                    <img
                                        style={{
                                            width: "200px",
                                            height: "200px",
                                            margin: "auto"
                                        }}
                                        src={
                                            report.signature_3_url ===
                                                undefined ||
                                            report.signature_3_url === null ||
                                            report.signature_3_url === ""
                                                ? noSig
                                                : report.signature_3_url
                                        }
                                        alt="Signature"
                                    />
                                </div>
                            </div>
                        )}
                        {report.name_4 !== "" && (
                            <div style={gstyle(6, 17, 6.16)}>
                                <div style={cstyle(1, 1, 1, 17, true)}>
                                    <b>Person 4</b>
                                </div>
                                <div style={cstyle(2, 1, 2, 9)}>
                                    <b>Name</b>
                                </div>
                                <div style={cstyle(2, 4, 2, 9, false, true)}>
                                    {report.name_4}
                                </div>
                                <div style={cstyle(3, 1, 3, 9)}>
                                    <b>Date</b>
                                </div>
                                <div style={cstyle(3, 4, 3, 9, false, true)}>
                                    {report.date_4}
                                </div>

                                <div style={cstyle(4, 1, 4, 9)}>
                                    <b>Reason For Visit</b>
                                </div>
                                <div style={cstyle(4, 4, 4, 9, false, true)}>
                                    {report.reason_4}
                                </div>

                                <div style={cstyle(5, 1, 5, 9)}>
                                    <b>Time In</b>
                                </div>
                                <div style={cstyle(5, 4, 5, 9, false, true)}>
                                    {report.time_in_4}
                                </div>

                                <div style={cstyle(6, 1, 6, 9)}>
                                    <b>Time Out</b>
                                </div>
                                <div style={cstyle(6, 4, 6, 9, false, true)}>
                                    {report.time_out_4}
                                </div>
                                <div style={cstyle(2, 9, 7, 17)}>
                                    <img
                                        style={{
                                            width: "200px",
                                            height: "200px",
                                            margin: "auto"
                                        }}
                                        src={
                                            report.signature_4_url ===
                                                undefined ||
                                            report.signature_4_url === null ||
                                            report.signature_4_url === ""
                                                ? noSig
                                                : report.signature_4_url
                                        }
                                        alt="Signature"
                                    />
                                </div>
                            </div>
                        )}
                        {report.name_5 !== "" && (
                            <div style={gstyle(6, 17, 6.16)}>
                                <div style={cstyle(1, 1, 1, 17, true)}>
                                    <b>Person 5</b>
                                </div>
                                <div style={cstyle(2, 1, 2, 9)}>
                                    <b>Name</b>
                                </div>
                                <div style={cstyle(2, 4, 2, 9, false, true)}>
                                    {report.name_5}
                                </div>
                                <div style={cstyle(3, 1, 3, 9)}>
                                    <b>Date</b>
                                </div>
                                <div style={cstyle(3, 4, 3, 9, false, true)}>
                                    {report.date_5}
                                </div>

                                <div style={cstyle(4, 1, 4, 9)}>
                                    <b>Reason For Visit</b>
                                </div>
                                <div style={cstyle(4, 4, 4, 9, false, true)}>
                                    {report.reason_5}
                                </div>

                                <div style={cstyle(5, 1, 5, 9)}>
                                    <b>Time In</b>
                                </div>
                                <div style={cstyle(5, 4, 5, 9, false, true)}>
                                    {report.time_in_5}
                                </div>

                                <div style={cstyle(6, 1, 6, 9)}>
                                    <b>Time Out</b>
                                </div>
                                <div style={cstyle(6, 4, 6, 9, false, true)}>
                                    {report.time_out_5}
                                </div>
                                <div style={cstyle(2, 9, 7, 17)}>
                                    <img
                                        style={{
                                            width: "200px",
                                            height: "200px",
                                            margin: "auto"
                                        }}
                                        src={
                                            report.signature_5_url ===
                                                undefined ||
                                            report.signature_5_url === null ||
                                            report.signature_5_url === ""
                                                ? noSig
                                                : report.signature_5_url
                                        }
                                        alt="Signature"
                                    />
                                </div>
                            </div>
                        )}
                        {report.name_6 !== "" && (
                            <div style={gstyle(6, 17, 6.16)}>
                                <div style={cstyle(1, 1, 1, 17, true)}>
                                    <b>Person 6</b>
                                </div>
                                <div style={cstyle(2, 1, 2, 9)}>
                                    <b>Name</b>
                                </div>
                                <div style={cstyle(2, 4, 2, 9, false, true)}>
                                    {report.name_6}
                                </div>
                                <div style={cstyle(3, 1, 3, 9)}>
                                    <b>Date</b>
                                </div>
                                <div style={cstyle(3, 4, 3, 9, false, true)}>
                                    {report.date_6}
                                </div>

                                <div style={cstyle(4, 1, 4, 9)}>
                                    <b>Reason For Visit</b>
                                </div>
                                <div style={cstyle(4, 4, 4, 9, false, true)}>
                                    {report.reason_6}
                                </div>

                                <div style={cstyle(5, 1, 5, 9)}>
                                    <b>Time In</b>
                                </div>
                                <div style={cstyle(5, 4, 5, 9, false, true)}>
                                    {report.time_in_6}
                                </div>

                                <div style={cstyle(6, 1, 6, 9)}>
                                    <b>Time Out</b>
                                </div>
                                <div style={cstyle(6, 4, 6, 9, false, true)}>
                                    {report.time_out_6}
                                </div>
                                <div style={cstyle(2, 9, 7, 17)}>
                                    <img
                                        style={{
                                            width: "200px",
                                            height: "200px",
                                            margin: "auto"
                                        }}
                                        src={
                                            report.signature_6_url ===
                                                undefined ||
                                            report.signature_6_url === null ||
                                            report.signature_6_url === ""
                                                ? noSig
                                                : report.signature_6_url
                                        }
                                        alt="Signature"
                                    />
                                </div>
                            </div>
                        )}
                        {report.name_7 !== "" && (
                            <div style={gstyle(6, 17, 6.16)}>
                                <div style={cstyle(1, 1, 1, 17, true)}>
                                    <b>Person 7</b>
                                </div>
                                <div style={cstyle(2, 1, 2, 9)}>
                                    <b>Name</b>
                                </div>
                                <div style={cstyle(2, 4, 2, 9, false, true)}>
                                    {report.name_7}
                                </div>
                                <div style={cstyle(3, 1, 3, 9)}>
                                    <b>Date</b>
                                </div>
                                <div style={cstyle(3, 4, 3, 9, false, true)}>
                                    {report.date_7}
                                </div>

                                <div style={cstyle(4, 1, 4, 9)}>
                                    <b>Reason For Visit</b>
                                </div>
                                <div style={cstyle(4, 4, 4, 9, false, true)}>
                                    {report.reason_7}
                                </div>

                                <div style={cstyle(5, 1, 5, 9)}>
                                    <b>Time In</b>
                                </div>
                                <div style={cstyle(5, 4, 5, 9, false, true)}>
                                    {report.time_in_7}
                                </div>

                                <div style={cstyle(6, 1, 6, 9)}>
                                    <b>Time Out</b>
                                </div>
                                <div style={cstyle(6, 4, 6, 9, false, true)}>
                                    {report.time_out_7}
                                </div>
                                <div style={cstyle(2, 9, 7, 17)}>
                                    <img
                                        style={{
                                            width: "200px",
                                            height: "200px",
                                            margin: "auto"
                                        }}
                                        src={
                                            report.signature_7_url ===
                                                undefined ||
                                            report.signature_7_url === null ||
                                            report.signature_7_url === ""
                                                ? noSig
                                                : report.signature_7_url
                                        }
                                        alt="Signature"
                                    />
                                </div>
                            </div>
                        )}
                        {/* <div
                            style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "space-between",
                                flexDirection: "row-reverse"
                            }}
                        >
                            <ProWorkFooter.view />
                        </div> */}
                    </div>
                </CardContent>
            </Card>
        );
    }
}

export default connect(
    store => {
        return {
            report: selectReport(store)
        };
    },
    { getReport, getJobPackReports }
)(HealthAndSafety);
